





















import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "sbModal"
})
export default class SbModal extends Vue {
  @Prop({ default: false }) private open!: boolean;
}
